// extracted by mini-css-extract-plugin
export default {"table":"UserList_table__5Hvl8"};